/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface OptimizationRun
 */
export interface OptimizationRun {
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  planId: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  planName: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  optimizedPlanId?: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  createdBy: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  updatedAt: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  finishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  state: OptimizationRunStateEnum;
  /**
   *
   * @type {number}
   * @memberof OptimizationRun
   */
  elapsedTime?: number;
  /**
   *
   * @type {number}
   * @memberof OptimizationRun
   */
  progress?: number;
  /**
   *
   * @type {number}
   * @memberof OptimizationRun
   */
  maxtime?: number;
  /**
   *
   * @type {number}
   * @memberof OptimizationRun
   */
  solutionGap?: number;
  /**
   *
   * @type {string}
   * @memberof OptimizationRun
   */
  solutionAlgorithm?: string;
  /**
   *
   * @type {boolean}
   * @memberof OptimizationRun
   */
  solutionGapFailed?: boolean;
}

export const OptimizationRunStateEnum = {
  Pending: 'pending',
  Started: 'started',
  Success: 'success',
  Failure: 'failure',
  Canceled: 'canceled',
} as const;

export type OptimizationRunStateEnum = (typeof OptimizationRunStateEnum)[keyof typeof OptimizationRunStateEnum];
